import { mainAdminSplitApi } from 'redux/store/mainSplitApi'

import type { RasnEvent, RasnEventPayload } from '../types'

const eventApi = mainAdminSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    retriggerUnitEvents: builder.mutation<{ missingIds: string[], processed: number }, { type: string, unitIds: string[] }>({
      query: ({ type, unitIds }) => {
        return {
          url: '/events/retrigger',
          method: 'POST',
          body: {
            type,
            unitIds
          }
        }
      }
    }),
    getRasnEventPayload: builder.query<RasnEventPayload, RasnEvent>({
      query: (rasnEvent) => {
        const { externalId, version, timestamp } = rasnEvent
        const dateObj = typeof timestamp === 'number' ? new Date(timestamp) : timestamp
        const date = dateObj.toISOString().split('T')[0] // Formatted as YYYY-MM-DD
        return {
          url: `/events/${encodeURIComponent(String(externalId))}/${encodeURIComponent(String(version))}/payload`,
          params: {
            date
          }
        }
      }
    })
  })
})

export const { useRetriggerUnitEventsMutation, useGetRasnEventPayloadQuery } = eventApi
